<template>
  <div id="app">
    <electronic-scroll :content="content" v-if="doShowElectronicScrollInner"></electronic-scroll>

    <dialog-wakeUp :content="content" :dialogVisible="showDialogInner"></dialog-wakeUp>

    <!-- 客服單通知 -->
    <el-dialog
      class="dialog-dialog"
      @closed="innerDialogVisible = false"
      title="系統通知"
      :visible.sync="innerDialogVisible"
      append-to-body
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :show-close="false"
      :width="device == 'mobile' ? '90%' : '60%'"
    >
      <div>
        <el-alert
          style="background-color: #ffd643; color: #4b4b4b"
          :title="customerComplaintContent"
          type="info"
          effect="dark"
          show-icon
          :closable="false"
        >
        </el-alert>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="innerDialogVisible = false">關 閉</el-button>
      </div>
    </el-dialog>

    <!-- 浮動小視窗 (僅桌面版顯示) -->
    <div v-if="webAiUrl && !isMobile && !isMinimized" class="floating-window">
      <button class="close-btn" @click="minimizeFloatingWindow">×</button>
      <img src="@/assets/images/WebAI.png" alt="Web AI" @click="openWebAiUrl" />
    </div>

    <!-- 縮小後的圓形圖示 -->
    <div
      v-if="webAiUrl && !isMobile && isMinimized"
      class="floating-circle"
      @click="restoreFloatingWindow"
    >
      <img src="@/assets/images/AICircle.png" alt="Web AI Minimized" />
    </div>

    <!-- 全螢幕視窗 -->
    <div v-if="isFullScreen" class="full-screen-overlay">
      <button class="close-fullscreen-btn" @click="closeFullScreen">×</button>
      <iframe
        v-if="webAiUrl"
        :src="webAiUrlWithAgency"
        frameborder="0"
        class="full-screen-iframe"
        allow="microphone"
      ></iframe>
    </div>

    <!-- Web AI 右側彈框 -->
    <el-drawer title="Web AI" :visible.sync="drawerVisible" size="50%" :with-header="false">
      <iframe
        v-if="webAiUrl"
        :src="webAiUrlWithAgency"
        frameborder="0"
        style="width: 100%; height: 100%"
        allow="microphone"
      ></iframe>
    </el-drawer>

    <!-- Footer (僅手機版顯示 WebAIMobile.png) -->
    <footer v-if="isMobile" class="mobile-footer">
      <img
        v-if="webAiUrl"
        src="@/assets/images/WebAIMobile.png"
        alt="Web AI Mobile"
        @click="openWebAiUrl"
      />
    </footer>

    <router-view />
  </div>
</template>

<script>
import ElectronicScroll from '@/views/ita/components/electronicScrollComponents.vue'
import DialogWakeUp from '@/views/ita/components/dialogComponents.vue'
import { mapState } from 'vuex'
import { toDoAgencyNotify } from '@/api/unity'
import { getToken } from '@/utils/auth'
import { getNotSolveFaultBack } from './api/appManage'
import { getCustomerComplaintNotify } from './api/agency'

var tokenLoop
export default {
  name: 'App',
  // metaInfo: {
  //   title: "團體旅遊應用系統",
  //   titleTemplate: "%s-智遊旅程後台管理系統",
  // },
  components: {
    ElectronicScroll,
    DialogWakeUp,
  },
  computed: {
    ...mapState('user', ['webAiUrl']),
    ...mapState(['showElectronicScroll', 'showDialog', 'showNotify', 'device']),
    // 從 user module 正確映射 userInfo
    ...mapState('user', {
      userModule: state => state,
      userInfo: state => state.userInfo, // 從 user module 取得 userInfo
    }),
    isMobile() {
      // 根據 windowWidth 動態計算是否為手機版
      return this.windowWidth <= 768
    },
    // 新增 computed 屬性來確保 agencyCode 有正確的值
    currentAgencyCode() {
      // 現在 userInfo 來自正確的位置，優先順序：本地變數 -> userInfo -> 空字串
      return this.agencyCode || (this.userInfo && this.userInfo.agencyCode) || ''
    },
    // 新增 computed 屬性來生成完整的 webAi URL
    webAiUrlWithAgency() {
      if (!this.webAiUrl) return ''
      if (this.webAiUrl.includes('?')) {
        return `${this.webAiUrl}&agencyCode=${this.currentAgencyCode}`
      }
      return `${this.webAiUrl}`
    },
  },
  watch: {
    token: {
      handler: function (newVal, oldVal) {
        if (newVal && !this.isGetToken) {
          this.isGetToken = true
          if (tokenLoop) {
            clearInterval(tokenLoop)
            tokenLoop = null
          }
          // alert("onNavBar", newVal);
          this.ws.close()
          this.ws.connect()
          this.wsGroup.close()
          this.wsGroup.connect()
        }
      },
      deep: true,
      immediate: true,
    },
    showElectronicScroll: {
      handler: function (newVal, oldVal) {
        this.doShowElectronicScrollInner = newVal
      },
      deep: true,
      immediate: true,
    },
    showDialog: {
      handler: function (newVal, oldVal) {
        this.showDialogInner = newVal
      },
      deep: true,
      immediate: true,
    },
    showNotify: {
      handler: function (newVal, oldVal) {
        this.showNotifyInner = newVal
      },
      deep: true,
      immediate: true,
    },
    userInfo: {
      handler: async function (newVal, oldVal) {
        if (newVal && newVal.agencyCode) {
          this.agencyCode = newVal.agencyCode
          await getCustomerComplaintNotify().then(response => {
            if (response.data) {
              this.customerComplaintContent = '近兩日有客服單，請至客服與紀錄資訊查看。'
              this.innerDialogVisible = true
            }
          })

          setTimeout(async () => {
            await toDoAgencyNotify()
          }, 2000)
        } else if (newVal && newVal.agencyCode == null && newVal.userID) {
          this.agencyCode = null
          getNotSolveFaultBack().then(response => {
            const count = parseInt(response.data)
            this.$store.dispatch('app/setFaultBackCount', parseInt(count))
          })
        }
      },
      deep: true,
      immediate: true,
    },
    isReceive(current, old) {
      if (!current) {
        clearInterval(this.timer) //停止
      }
    },
  },
  data() {
    return {
      ws: null,
      wsGroup: null,
      showin: true,
      agencyCode: null,
      doShowElectronicScrollInner: false,
      showDialogInner: false,
      showNotifyInner: false,
      token: null,
      content: null,
      isGetToken: false,
      wsState: null,
      isReceive: false,
      timer: null,
      innerDialogVisible: false,
      customerComplaintContent: '',
      drawerVisible: false, // 控制右側彈框的顯示
      isFullScreen: false, // 控制全螢幕視窗的顯示
      isMinimized: false, // 控制浮動小視窗是否縮小
      windowWidth: window.innerWidth, // 新增 windowWidth 來追蹤視窗寬度
    }
  },
  created() {
    // 監聽視窗尺寸變化
    window.addEventListener('resize', this.updateWindowWidth)

    tokenLoop = setInterval(() => {
      if (!this.token) {
        // console.log('try gettoken');
        this.token = getToken()
      }
    }, 1000)

    this.ws = this.$socket
    this.wsGroup = this.$socketGroup

    // 設定初始 agencyCode，現在 userInfo 來自正確的位置
    this.agencyCode = (this.userInfo && this.userInfo.agencyCode) || null

    this.ws.$on('message', this.handleGetMessage)
    // this.wsGroup.$on('message', this.handleGetMessage) // 群組訊息不需要再多一個通知
  },
  async mounted() {
    // console.log('app.vue onMounted')

    // // 添加 debug 信息
    // console.log('===> Debug store state:')
    // console.log('===> this.$store.state.userInfo:', this.$store.state.userInfo)
    // console.log('===> this.$store.state.user:', this.$store.state.user)
    // console.log('===> this.userInfo:', this.userInfo)
    // console.log('===> this.agencyCode:', this.agencyCode)

    // // 定時檢查 userInfo 狀態
    // const checkUserInfo = () => {
    //   console.log('===> Periodic check - userInfo:', this.userInfo)
    //   console.log('===> Periodic check - agencyCode:', this.agencyCode)
    // }

    // 每 3 秒檢查一次，總共檢查 5 次
    for (let i = 1; i <= 5; i++) {
      setTimeout(checkUserInfo, i * 3000)
    }
  },
  methods: {
    openWebAiUrl() {
      if (this.isMobile) {
        this.openFullScreen()
      } else {
        this.drawerVisible = true
      }
    },
    minimizeFloatingWindow() {
      this.isMinimized = true // 將浮動小視窗縮小
    },
    restoreFloatingWindow() {
      this.isMinimized = false // 恢復浮動小視窗
    },
    openFullScreen() {
      // if (this.webAiUrl) {
      //   window.open(this.webAiUrl, '_blank') // 開啟新視窗全畫面
      // }
      this.isFullScreen = true // 顯示全螢幕視窗
    },
    closeFullScreen() {
      this.isFullScreen = false // 關閉全螢幕視窗
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth // 更新 windowWidth
    },
    setStoreShowEscroll(doing) {
      this.$store.dispatch('app/showEscroll', doing)
    },
    setDialog(doing) {
      this.$store.dispatch('app/showDialog', doing)
    },
    setNotify(doing) {
      this.$store.dispatch('app/showNotify', doing)
    },
    async handleGetMessage(msg) {
      const vm = this
      const res = JSON.parse(msg.data)
      //故障與回報通知
      if (
        res.type &&
        res.type == 1659 &&
        vm.agencyCode == null &&
        res.userId !== vm.userInfo.userID
      ) {
        this.showNotification('故障與回報通知')
        getNotSolveFaultBack().then(response => {
          const count = parseInt(response.data)
          this.$store.dispatch('app/setFaultBackCount', parseInt(count))
        })
      }

      //收到別人來訊
      if (res.type && res.type == 3) {
        this.showNotification('訊息通知')
        this.$notify.info({
          title: '訊息通知',
          message: '您有一條新訊息，請到即時訊息查看。',
        })
      }

      if (!vm.agencyCode) {
        return
      }

      if (res.type && res.type == 1658 && vm.agencyCode && res.agencyCode == vm.agencyCode) {
        vm.content = res.notifyContent

        switch (res.notifyType) {
          case 1: //財務新上傳檔案通知
            break
          default:
            break
        }

        switch (res.notifyStyle) {
          case 1: //跑馬燈
            vm.setStoreShowEscroll(true)
            break
          case 2: //彈跳視窗
            vm.setDialog(true)
            break
          case 3: //訊息視窗
            vm.setNotify(true)
            const h = this.$createElement
            this.$notify({
              title: '系統通知',
              message: h('i', { style: 'color: teal' }, `${vm.content}`),
              duration: 10000,
            })
            break
          default:
            break
        }
        this.showNotification('系統通知')
      }
      //客服通知
      if (res.type && res.type == 1660 && vm.agencyCode && res.agencyCode == vm.agencyCode) {
        vm.content = res.content
        vm.setDialog(true)
        this.showNotification('客服通知')
      }
    },
    showNotification(val) {
      let that = this
      if (!document.hasFocus()) {
        var options = {
          body: '您有未讀訊息，請立即查看',
          silent: false,
        }
        var notification = new Notification('【團體旅遊應用系統-' + val + '】', options)
        notification.onclick = function () {
          window.focus()
        }
        //在layout-Navbar已做
        // var defaultTitle = JSON.parse(JSON.stringify(document.title));
        // if (that.isReceive) {
        //   return false;
        // } else {
        //   that.isReceive = true;
        // }
        // that.timer = setInterval(function () {
        //   if (!document.hasFocus() && that.isReceive) {
        //     if (/你有新消息/.test(document.title) == false) {
        //       document.title = "【你有新消息】";
        //     } else {
        //       document.title = defaultTitle;
        //     }
        //   } else {
        //     that.isReceive = false;
        //     document.title = defaultTitle;
        //   }
        // }, 600);
      }
    },
  },
  destroyed() {
    console.log('App.vue 被銷毀了')
    window.removeEventListener('resize', this.updateWindowWidth) // 移除監聽器
  },
  deactivated() {
    console.log('App.vue 被停用了')
  },
  activated() {
    console.log('App.vue 被激活了')
  },
}
</script>

<style>
.app-main {
  position: relative;
}
.el-dialog__header {
  padding: 15px !important;
}
.el-dialog__footer {
  padding: 15px !important;
}
.el-pagination.is-background .btn-prev {
  margin-left: 0px !important;
}
.el-card__body {
  padding: 15px !important;
}

/* filter-form 表格篩選列表 */
.filter-form {
  border-radius: 10px;
  /* border: 1px solid #11d073; */
  border: 1px solid #ffe06f;
  padding: 10px;
  margin-bottom: 15px;
}
.filter-form .el-form-item {
  position: relative;
  /* margin-bottom: 0px !important; */
  border: 0.5px solid #ccc;
  border-radius: 3px;
  margin: 3px;
}

.filter-form .el-form-item__label {
  position: absolute;
  left: 4px;
  z-index: 5;
  top: -9px;
}

.filter-form .el-input--medium .el-input__inner {
  height: 30px !important;
  margin-top: 12px !important;
  border: none !important;
}

.filter-form .el-date-editor {
  margin-top: 8px !important;
  height: 37px !important;
  border: none !important;
}

.el-tag {
  white-space: normal;
  height: auto;
}

/* 浮動小視窗樣式 */
.floating-window {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  cursor: pointer;
  width: 20%; /* WebAI.png 調整寬度 */
  height: auto; /* WebAI.png  調整高度 */
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

/* 浮動小視窗的標題和關閉按鈕 */
.floating-window img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* 浮動小視窗的標題 */
.floating-window .close-btn {
  position: absolute;
  top: 5px;
  left: 5px;
  /* background: red; */
  background: rgba(255, 0, 0, 0);
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 浮動小視窗的縮小圖示 */
.floating-circle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 浮動小視窗的縮小圖示 */
.floating-circle img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 手機版底部AI樣式 */
.mobile-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f8f8f8;
  text-align: center;
  padding: 10px 0;
  z-index: 1000;
}

/* 手機版底部AI的圖片樣式 */
.mobile-footer img {
  width: 100%; /* 寬度填滿畫面 */
  height: auto; /* 高度自動調整，保持比例 */
  cursor: pointer;
}

/* 手機版全螢幕視窗樣式 */
.full-screen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8); /* 半透明背景 */
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 全螢幕視窗的內容 */
.full-screen-iframe {
  width: 90%;
  height: 90%;
  border: none;
  background-color: white;
}

/* 全螢幕視窗的關閉 */
.close-fullscreen-btn {
  position: absolute;
  top: 20px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2100;
}

/* 為頁面內容增加底部間距 */
#app {
  padding-bottom: 0; /* 預設為 0 */
}

@media (max-width: 768px) {
  #app {
    padding-bottom: 60px; /* 僅在手機版時調整 */
  }
  .floating-window {
    display: none; /* 手機版隱藏浮動視窗 */
  }
}
</style>
